import React from "react";
import tw, { css } from "twin.macro";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

function PartnerSection() {
  const buttonVariants = {
    hover: {
      scale: 1.2,
      originX: 0,
    },
  };

  return (
    <>
      <div tw="bg-primary">
        <div tw="container mx-auto xl:px-24 md:py-52 py-12 flex flex-col items-center">
          <div tw="sm:w-auto w-4/5">
            <motion.p
              initial={{ y: -200 }}
              animate={{ y: 0 }}
              transition={{ ease: "easeIn", duration: 0.5 }}
              tw="text-secondary text-lg font-medium"
            >
              Less time,
            </motion.p>
            <motion.h1
              initial={{ y: -400 }}
              animate={{ y: 0 }}
              transition={{ ease: "easeIn", delay: 0.5 }}
              css={[
                tw`text-secondary lg:text-9xl sm:text-7xl text-4xl font-black sm:mt-2 mt-0`,
                css`
                  @media screen and (min-width: 768px) {
                    line-height: 4rem;
                  }

                  @media screen and (max-width: 320px) {
                    font-size: 3rem;
                  }
                `,
              ]}
            >
              more money.
            </motion.h1>
          </div>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ ease: "easeOut", delay: 1 }}
            tw="lg:w-1/4 md:w-1/2 w-3/5 lg:mt-12 mt-4"
          >
            <p tw="text-secondary md:text-base text-xs font-medium mb-4">
              Join Glint’s team of part-time car cleaning partners and earn
              every day.
            </p>
            <motion.p variants={buttonVariants} whileHover="hover">
              <p tw="text-secondary text-2xl font-extrabold w-max">
                📞 +91-9384016215
              </p>
            </motion.p>
          </motion.div>
        </div>
      </div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ ease: "easeIn", delay: 1.5 }}
      >
        <div tw="bg-secondary pb-10">
          <div tw="container mx-auto">
            <div tw="sm:px-24 px-12 py-10">
              <h1 tw="text-white sm:text-3xl text-xl font-extrabold">
                we sell <span tw="text-primary">convenience.</span>
              </h1>
              <p tw="text-white font-semibold">
                No prior work experience required.
              </p>
            </div>
            <div tw="grid grid-cols-2 sm:px-24 px-6">
              <div tw="xl:w-2/5 lg:w-1/2 bg-primary p-4">
                <h1 tw="md:text-lg text-sm font-bold">Earn more.</h1>
                <div tw="w-8 h-1 bg-secondary my-2" />
                <p tw="md:text-base text-xs font-semibold">
                  Work for a fixed number of hours, earn a steady income of upto
                  20k a month.
                </p>
              </div>
              <div tw="xl:w-2/5 lg:w-1/2 bg-tertiary p-4">
                <h1 tw="text-white md:text-lg text-sm font-bold">Work less.</h1>
                <div tw="w-8 h-1 bg-primary my-2" />
                <p tw="md:text-base text-xs text-white font-semibold">
                  Part-time job opportunities - work for 3-4 hours a day.
                </p>
              </div>
              <div tw="xl:w-2/5 lg:w-1/2 bg-tertiary p-4 justify-self-end">
                <h1 tw="text-white md:text-lg text-sm font-bold">
                  Welcome kit.
                </h1>
                <div tw="w-8 h-1 bg-primary my-2" />
                <p tw="md:text-base text-xs text-white font-semibold">
                  Get on board with your own welcome kit including a brand new
                  Glint t-shirt.
                </p>
              </div>
              <div tw="xl:w-2/5 lg:w-1/2 bg-primary p-4 justify-self-end">
                <h1 tw="md:text-lg text-sm font-bold">No prior experience.</h1>
                <div tw="w-8 h-1 bg-secondary my-2" />
                <p tw="md:text-base text-xs font-semibold">
                  Complete training process - no prior car care experience
                  required.
                </p>
              </div>
              <div tw="xl:w-2/5 lg:w-1/2 bg-primary p-4 justify-self-start">
                <h1 tw="md:text-lg text-sm font-bold">
                  Low travel requirements.
                </h1>
                <div tw="w-8 h-1 bg-secondary my-2" />
                <p tw="md:text-base text-xs font-semibold">
                  All wash orders will be within 3 km. Spend less time
                  traveling, more time earning money.
                </p>
              </div>
              <div tw="xl:w-2/5 lg:w-1/2 bg-tertiary p-4">
                <h1 tw="text-white md:text-lg text-sm font-bold">
                  Grow with us.
                </h1>
                <div tw="w-8 h-1 bg-primary my-2" />
                <p tw="md:text-base text-xs text-white font-semibold">
                  Climb up the ladder with us to become a car cleaning expert.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div tw="bg-white">
          <div tw="container mx-auto py-12 flex flex-col">
            <div tw="w-max self-center">
              <h1 tw="text-gray-600 md:text-7xl sm:text-5xl text-3xl font-black">
                wash good,
              </h1>
              <h1 tw="text-primary md:text-7xl sm:text-5xl text-3xl font-black ml-24 pb-4">
                earn good.
              </h1>
              <p tw="text-gray-600 font-semibold">
                Learn more about{" "}
                <span tw="text-primary font-black">glint.</span>
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
}

export default PartnerSection;
